import './header-drawer-core.js';

// MAD VIBE CLUB — mobile top nav removed + dark iOS-inspired footer.
document.getElementById('mvc-ios-drawer-style')?.remove();
document.getElementById('mvc-ios-drawer-style-v2')?.remove();
document.getElementById('mvc-mobile-footer-style')?.remove();

const style = document.createElement('style');
style.id = 'mvc-mobile-footer-style';
style.textContent = `
  /* Remove the floating mobile top navigation completely. */
  @media screen and (max-width: 749px) {
    #header-component { display: none !important; }
  }

  /* Force the newsletter/footer region to the new black MAD VIBE CLUB treatment. */
  footer.section-wrapper:has(.footer-content) .section-background,
  footer.section-wrapper:has(.footer-content) .section {
    background: #08090b !important;
    --color-background: #08090b !important;
    --color-foreground: #f7f7f9 !important;
    --color-foreground-heading: #ffffff !important;
    --color-primary: #ff97df !important;
    --color-primary-hover: #ffffff !important;
    --color-border: rgba(255,255,255,.16) !important;
  }

  .footer-content {
    position: relative !important;
    isolation: isolate;
    color: #f7f7f9 !important;
  }

  .footer-content::before {
    content: '';
    position: absolute;
    inset: -24px;
    z-index: -1;
    pointer-events: none;
    border: 1px solid rgba(255,255,255,.085);
    border-radius: 32px;
    background:
      radial-gradient(circle at 88% 10%, rgba(255,151,223,.15), transparent 34%),
      radial-gradient(circle at 12% 88%, rgba(255,255,255,.05), transparent 30%),
      linear-gradient(145deg, rgba(255,255,255,.048), rgba(255,255,255,.012));
    -webkit-backdrop-filter: blur(22px) saturate(1.12);
    backdrop-filter: blur(22px) saturate(1.12);
    box-shadow: inset 0 1px 0 rgba(255,255,255,.085), 0 24px 68px rgba(0,0,0,.3);
  }

  .footer-content > * { position: relative; z-index: 1; }

  .footer-content h2 {
    color: transparent !important;
    background: linear-gradient(92deg, #ffffff 0%, #ffffff 52%, #ff97df 69%, #ffffff 86%) !important;
    background-size: 220% 100% !important;
    -webkit-background-clip: text !important;
    background-clip: text !important;
    letter-spacing: -.045em !important;
    text-wrap: balance;
    text-shadow: 0 0 28px rgba(255,151,223,.08);
  }

  .footer-content p {
    color: rgba(255,255,255,.76) !important;
  }

  .footer-content .email-signup__input-group {
    border-radius: 24px !important;
    border: 1px solid rgba(255,255,255,.16) !important;
    background: rgba(255,255,255,.065) !important;
    -webkit-backdrop-filter: blur(18px) saturate(1.12) !important;
    backdrop-filter: blur(18px) saturate(1.12) !important;
    box-shadow: inset 0 1px 0 rgba(255,255,255,.075), 0 12px 34px rgba(0,0,0,.2) !important;
    transition: border-color .24s ease, box-shadow .24s ease, transform .24s ease !important;
    overflow: hidden;
  }

  .footer-content .email-signup__input-group:focus-within {
    border-color: rgba(255,151,223,.72) !important;
    box-shadow: 0 0 0 4px rgba(255,151,223,.09), inset 0 1px 0 rgba(255,255,255,.09) !important;
    transform: translateY(-1px);
  }

  .footer-content .email-signup__input {
    color: #fff !important;
    background: transparent !important;
    border-color: transparent !important;
  }

  .footer-content .email-signup__input::placeholder {
    color: rgba(255,255,255,.48) !important;
  }

  .footer-content .email-signup__button,
  .footer-content .email-signup__button-icon {
    color: #ff97df !important;
    transition: transform .24s ease, opacity .24s ease !important;
  }

  .footer-content .email-signup__button:hover,
  .footer-content .email-signup__button:focus-visible {
    transform: translateX(4px) scale(1.035);
  }

  .footer-utilities {
    background: #08090b !important;
    color: #b7b7c0 !important;
    border-top: 1px solid rgba(255,255,255,.08) !important;
    --color-background: #08090b !important;
    --color-foreground: #b7b7c0 !important;
    --color-primary: #ff97df !important;
  }

  .footer-utilities a { transition: color .22s ease, opacity .22s ease !important; }
  .footer-utilities a:hover,
  .footer-utilities a:focus-visible { color: #ff97df !important; }

  @media (prefers-reduced-motion: no-preference) {
    .footer-content h2 { animation: mvcFooterShimmer 7s ease-in-out infinite; }
    .footer-content::before { animation: mvcFooterGlow 7s ease-in-out infinite; }
  }

  @keyframes mvcFooterShimmer {
    0%, 100% { background-position: 0% 50%; transform: translateY(0); }
    50% { background-position: 100% 50%; transform: translateY(-2px); }
  }

  @keyframes mvcFooterGlow {
    0%, 100% { opacity: .93; }
    50% { opacity: 1; }
  }

  @media screen and (max-width: 749px) {
    .footer-content::before { inset: -15px; border-radius: 26px; }
    .footer-content h2 {
      font-size: clamp(34px, 10vw, 46px) !important;
      line-height: .99 !important;
    }
    .footer-content p {
      font-size: clamp(18px, 5.2vw, 22px) !important;
      line-height: 1.42 !important;
    }
    .footer-content .email-signup__input-group { border-radius: 21px !important; }
  }
`;
document.head.appendChild(style);
